export const PROGRAMS = [
  {
    slug: "brotherhood",
    name: "Brotherhood",
    tagline: "Men becoming fathers, mentors and leaders.",
    description:
      "A 12-week cohort for men navigating reentry, fatherhood, recovery or a hard reset. Weekly circles, one-to-one mentorship, career coaching and a rite-of-passage retreat.",
    highlights: ["Weekly small groups", "One-to-one mentorship", "Career + trades coaching", "Rite-of-passage retreat"],
    image: "https://images.unsplash.com/photo-1778864874528-696db2f002bd?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
    accent: "clay",
  },
  {
    slug: "sisterhood",
    name: "Sisterhood",
    tagline: "Women rising in dignity, purpose and community.",
    description:
      "A restorative circle for women rebuilding after trauma, loss or transition. Emphasizes emotional wellness, financial literacy, motherhood support and vocational discovery.",
    highlights: ["Trauma-informed circles", "Financial literacy", "Motherhood support", "Vocation coaching"],
    image: "https://images.unsplash.com/photo-1544928938-6852c1925194?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
    accent: "sage",
  },
  {
    slug: "youth",
    name: "Youth",
    tagline: "Teens discovering the leader inside them.",
    description:
      "For ages 12–18. After-school mentorship, tutoring, life-skills labs and paid summer leadership fellowships. Every teen is paired with a caring adult mentor.",
    highlights: ["1:1 mentor pairing", "Homework + tutoring", "Life-skills labs", "Paid summer fellowship"],
    image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
    accent: "clay",
  },
  {
    slug: "family_restoration",
    name: "Family Restoration",
    tagline: "Reconciled homes. Stable futures.",
    description:
      "Case-managed support for families in crisis: reunification coaching, housing navigation, counseling referrals and a quarterly retreat that brings families back together.",
    highlights: ["Case management", "Reunification coaching", "Housing navigation", "Family retreats"],
    image: "https://images.unsplash.com/photo-1609220136736-443140cffec6?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
    accent: "sage",
  },
];
